export default __webpack_public_path__ + "static/media/FICHA TÉCNICA- MELÃO AMARELO.4b73e7dd.pdf";